
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMotorOffVertical as ObiMotorOffVerticalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-motor-off-vertical.js';
 
 
 

 
 export const ObiMotorOffVertical = createComponent({
   react: React,
   tagName: 'obi-motor-off-vertical',
   elementClass: ObiMotorOffVerticalElement,
   events: {
     
   }
  });
 
 